import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { IExportRequest } from "interfaces/export-duck";
import { requestErrorHandler } from "utils";
import { ExportSchedulingOrderFOBActions } from "store/ducks/ordersFob";

export function* exportSchedulingOrderFOBRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IExportRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(
      api.get,
      `/orders-fob-scheduled?${queryString}`
    );
    yield put(ExportSchedulingOrderFOBActions.success(data?.data));
    if (onSuccess) onSuccess(data?.data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ExportSchedulingOrderFOBActions.failure(errorMessage));
  }
}
